// extracted by mini-css-extract-plugin
export var body = "styles-module--body--87705";
export var form = "styles-module--form--24bef";
export var modal = "styles-module--modal--532e6";